<div
  id="app-loader"
  class="refreshing"
  [ngClass]="{ 'is-loading': (loader | async) }">
  <span class="loader lg"></span>
</div>
